(() => {
  if (customElements.get('wc-brands-menu')) return;
  class WCBrandsMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.closest('details');
      this.groups = [...this.querySelectorAll('[data-wc-brands-group]')];
      this.panels = [...this.querySelectorAll('[data-wc-brands-panel]')];
      if (!this.details || !this.groups.length || this.groups.length !== this.panels.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const activate = event => {
        const button = event.target.closest('[data-wc-brands-group]');
        if (button && this.contains(button)) this.select(this.groups.indexOf(button));
      };
      this.addEventListener('pointerover', activate, options);
      this.addEventListener('focusin', activate, options);
      this.addEventListener('click', activate, options);
      this.addEventListener('keydown', event => this.onKeydown(event), options);
      this.scheduleMeasure = () => {
        if (!this.details.open || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected && this.details.open) this.measure();
        });
      };
      this.onToggle = () => {
        this.openController?.abort();
        if (!this.details.open) return;
        this.openController = new AbortController();
        const openOptions = { signal: this.openController.signal, passive: true };
        window.addEventListener('resize', this.scheduleMeasure, openOptions);
        window.addEventListener('scroll', this.scheduleMeasure, openOptions);
        window.visualViewport?.addEventListener('resize', this.scheduleMeasure, openOptions);
        this.scheduleMeasure();
      };
      this.details.addEventListener('toggle', this.onToggle, options);
      this.querySelectorAll('[data-wc-brands-fallback]').forEach(link => { link.hidden = true; });
      this.groups.forEach(button => { button.hidden = false; });
      this.select(0);
      this.setAttribute('data-enhanced', '');
      this.onToggle();
    }

    select(index) {
      if (index < 0 || index >= this.groups.length) return;
      this.groups.forEach((button, i) => {
        button.setAttribute('aria-expanded', String(i === index));
        button.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }

    measure() {
      const dropdown = this.closest('.mega-menu');
      if (!dropdown) return;
      // Measure the unanimated wrapper, not the sliding mega-menu container.
      const inset = parseFloat(getComputedStyle(dropdown.firstElementChild).paddingTop) || 0;
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      const available = Math.max(0, Math.floor(bottom - dropdown.getBoundingClientRect().top - inset - 16));
      this.style.setProperty('--wc-brands-available-height', `${available}px`);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        this.details.querySelector('summary').focus();
        this.details.open = false;
        return;
      }
      const index = this.groups.indexOf(event.target.closest('[data-wc-brands-group]'));
      if (index < 0) return;
      const next = { ArrowDown: (index + 1) % this.groups.length, ArrowUp: (index + this.groups.length - 1) % this.groups.length,
        Home: 0, End: this.groups.length - 1 }[event.key];
      if (next === undefined) return;
      event.preventDefault();
      this.groups[next].focus();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.openController?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  }
  customElements.define('wc-brands-menu', WCBrandsMenu);
})();
